import React from 'react'
import style from './Verify.Module.css'
import image from '../../Assets/verify/Group 154.png'
import Header from '../../Component/Header'
import { useNavigate } from 'react-router';



   
  

const Verify = () => {
  let navigate = useNavigate();
  function handleClick() {
    navigate('/verifyStep2')
    }
    return (
        
           <div className={style.mainContainer}>
               <Header/>
        <div className={style.main}>
            
          <div className={style.boxContainer}>
            <div className={style.boxInsidecontainer}>
            
                    <div><img src={image} alt="png"/></div>
                    <div><h1 className={style.verifyHeading}>Verify your account</h1></div>
                    <div><p className={style.verifyParagraph}>Please verify your page with a photo.<br/>This will help us to stop catfishing</p></div>
                    <div><button className={style.mainButton} onClick={handleClick}>Verify</button></div>
                
            </div>
        </div>
        </div>
        </div> 
        
    )

}

export default Verify
